import { useQuery } from 'react-query';
import { axios } from '../api/axios';

export default function useGetDirect(memberId) {
  const query = useQuery(
    ['direct/get-messages', parseInt(memberId, 10)],
    () => axios.get('/direct/get_messages/', { params: { memberId } }),
    {
      cacheTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchInterval: 20000,
    },
  );

  return [query?.data?.data, query];
}
